import { QueryClient, focusManager } from '@tanstack/vue-query';
import { experimental_createQueryPersister } from '@tanstack/query-persist-client-core';
import { getSavedState } from '@utils/util';
import { AUTH_TOKEN } from '@utils/storageKeys';

// Server data the panel caches. A query refetches once stale when its screen
// mounts or the tab or window regains focus, so a panel left open catches up.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30 * 1000, retry: 1 },
  },
});

// vue-query only watches for the tab being shown again; coming back from
// another window or app, with the tab visible all along, counts too.
focusManager.setEventListener((onFocus) => {
  const listener = () => onFocus();
  window.addEventListener('visibilitychange', listener);
  window.addEventListener('focus', listener);
  return () => {
    window.removeEventListener('visibilitychange', listener);
    window.removeEventListener('focus', listener);
  };
});

// A localStorage copy between visits, for queries with `persister: localPersister.persisterFn`.
// No writes once signed out, so a late answer can't outlive logout's localStorage.clear().
export const localPersister = experimental_createQueryPersister({
  storage: {
    getItem: (key) => localStorage.getItem(key),
    setItem: (key, value) => getSavedState(AUTH_TOKEN) && localStorage.setItem(key, value),
    removeItem: (key) => localStorage.removeItem(key),
  },
  maxAge: 30 * 24 * 60 * 60 * 1000,
});
